import { Accordion, AccordionDetails, AccordionSummary, Autocomplete, Card, Grid, Icon, Modal, TextField } from "@mui/material";
import MDBox from "components/MDBox";
import MDEditor from "@uiw/react-md-editor";
import MDTypography from "components/MDTypography";
import React, { useEffect, useState } from "react";
import crudsService from "services/cruds-service";
import MDButton from "components/MDButton";
import ReactPlayer from "react-player";

const HomepageIntroduction = ({
    homePageIntroduction,
    podcastLink,
    setPodcastLink,
    previewVideoLink,
    setPreviewVideoLink,
    previewSlideDeckLink,
    setPreviewSlideDeckLink,
    setHomePageIntroduction,
    handleChange,
}) => {
    const [previewPodcastModal, setPreviewPodcastModal] = useState(false);
    const [previewVideoModal, setPreviewVideoModal] = useState(false);
    const [previewSlideDeckModal, setPreviewSlideDeckModal] = useState(false);



    const saveChanges = () => {
        handleChange({ target: { name: "home_page_introduction", value: homePageIntroduction } });
    }

    useEffect(() => {
        saveChanges();
    }, [homePageIntroduction]);



    return (
        <>

            <Modal
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
                open={previewVideoModal}
                onClose={() => setPreviewVideoModal(false)}
            >
                <Card
                    style={{
                        width: "50%",
                        padding: "20px",
                        justifyItems: "center",
                        display: "flex",
                    }}
                >
                    <ReactPlayer url={previewVideoLink} controls width="100%" pip />
                </Card>
            </Modal>
            <Modal
                open={previewPodcastModal}
                onClose={() => setPreviewPodcastModal(false)}
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Card
                    style={{
                        width: "80%",
                        maxWidth: "600px",
                        padding: "20px",
                        outline: "none",
                    }}
                >
                    <audio controls style={{ width: "100%" }}>
                        <source src={podcastLink} type="audio/mpeg" />
                        Your browser does not support the audio element.
                    </audio>
                </Card>
            </Modal>
            <Modal
                open={previewSlideDeckModal}
                onClose={() => setPreviewSlideDeckModal(false)}
                style={{
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                }}
            >
                <Card
                    style={{
                        width: "90%",
                        maxWidth: "900px",
                        height: "90vh",
                        padding: "20px",
                        outline: "none",
                        display: "flex",
                        flexDirection: "column",
                    }}
                >
                    <iframe
                        src={previewSlideDeckLink}
                        title="Slide Deck Preview"
                        style={{
                            width: "100%",
                            height: "100%",
                            border: "none",
                        }}
                    />
                </Card>
            </Modal>




            <Card style={{ width: "100%", padding: "20px", }}>
                <Grid container rowSpacing={2}>
                    <Grid item xs={12}>
                        <MDBox display="flex" justifyContent="space-between">
                            <MDTypography variant="h5" mb={2}>
                                Home Page Introduction
                            </MDTypography>
                        </MDBox>
                        <div data-color-mode="light" >
                            <MDEditor
                                value={homePageIntroduction}
                                onChange={setHomePageIntroduction}
                                height={300}
                            />
                        </div>
                    </Grid>
                </Grid>

                <Grid item xs={12} mt={2} display="flex" justifyContent="space-between">
                    <TextField
                        fullWidth
                        label="Podcast Link"
                        name="podcast_link"
                        value={podcastLink}
                        onChange={(e) => setPodcastLink(e.target.value)}
                    />
                    <MDButton
                        variant="caption"
                        
                        style={{ float: "right", marginLeft: "10px" }}
                        onClick={() => setPreviewPodcastModal(true)}
                        disabled={!podcastLink?.trim()}
                    >
                        Preview
                    </MDButton>
                </Grid>
                <Grid item xs={12} mt={2} display="flex" justifyContent="space-between">
                    <TextField
                        fullWidth
                        label="Preview Video Link"
                        name="preview_video_link"
                        value={previewVideoLink}
                        onChange={(e) => setPreviewVideoLink(e.target.value)}
                    />
                    <MDButton
                        variant="caption"
                        
                        style={{ float: "right", marginLeft: "10px" }}
                        onClick={() => setPreviewVideoModal(true)}
                        disabled={!previewVideoLink?.trim()}
                    >
                        Preview
                    </MDButton>
                </Grid>
                <Grid item xs={12} mt={2} display="flex" justifyContent="space-between">
                    <TextField
                        fullWidth
                        label="Preview SlideDeck Link"
                        name="preview_slide_deck_link"
                        value={previewSlideDeckLink}
                        onChange={(e) => setPreviewSlideDeckLink(e.target.value)}
                    />
                    <MDButton
                        variant="caption"
                        
                        style={{ float: "right", marginLeft: "10px" }}
                        onClick={() => setPreviewSlideDeckModal(true)}
                        disabled={!previewSlideDeckLink?.trim()}
                    >
                        Preview
                    </MDButton>
                </Grid>

            </Card>
        </>

    )
}

export default HomepageIntroduction;